/* eslint-disable */
// src/services/partnersPublicService.js

import {
    collection,
    getDocs,
    query,
    orderBy,
    limit as qlimit,
} from "firebase/firestore";

import { db } from "./firebase";

const COL = "partners"; // ✅ 관리자에서 쓰는 컬렉션명과 맞춰줘 (다르면 여기만 바꾸면 됨)

export async function listPartnersPublic(opts = {}) {
    const n = Number(opts?.limit);
    const lim = Number.isFinite(n) && n > 0 ? Math.min(n, 500) : 200;

    const colRef = collection(db, COL);
    const q = query(colRef, orderBy("updatedAt", "desc"), qlimit(lim));
    const snap = await getDocs(q);

    const rows = [];
    snap.forEach((d) => {
        rows.push({ id: d.id, ...(d.data() || {}) });
    });

    return rows;
}
